import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByWithParsing'
})
export class OrderByWithParsingPipe implements PipeTransform {
  transform(item: any[], rowOrder: string, reverse: boolean = false): any[] {
    if (!item || !rowOrder) {
      return item;
    }

    const sortedItems = item.slice().sort((a, b) => {
      const valueA: any = this.getValue(a[rowOrder]);
      const valueB: any = this.getValue(b[rowOrder]);

      // Handle null values
      if (valueA === null || valueA === undefined) return reverse ? 1 : -1;
      if (valueB === null || valueB === undefined) return reverse ? -1 : 1;

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return reverse ? valueB.localeCompare(valueA) : valueA.localeCompare(valueB);
      }

      return reverse ? valueB - valueA : valueA - valueB;
    });

    return sortedItems;
  }

  private getValue(value: any): number | Date | string {
    if (value == null || isNaN(value)) {
      if (value != null && value.indexOf('/') !== -1) {
        const parsedDate: any = Date.parse(value);
        const date: number = parsedDate as number;
        if (!isNaN(date)) {
          return date;
        }
      }
      return value;
    }
    return Number(value);
  }

}